import { useId, useState } from 'react'
import type { InputHTMLAttributes } from 'react'
import { TextInput } from '@/shared/ui/TextInput'
import { cn } from '@/shared/lib/cn'

interface PasswordInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string
  variant?: 'default' | 'muted'
}

export const PasswordInput = ({
  label,
  className,
  variant,
  disabled,
  ...props
}: PasswordInputProps) => {
  const [visible, setVisible] = useState(false)
  const inputId = useId()

  return (
    <div className="flex w-full flex-col gap-2">
      {label ? (
        <label
          htmlFor={inputId}
          className="text-xs font-medium text-[var(--color-text-secondary)]"
        >
          {label}
        </label>
      ) : null}
      <div className="relative w-full min-w-0">
        <TextInput
          {...props}
          id={props.id ?? inputId}
          bare
          type={visible ? 'text' : 'password'}
          variant={variant}
          disabled={disabled}
          className={cn('pr-10', className)}
        />
        <button
          type="button"
          disabled={disabled}
          onClick={() => setVisible((v) => !v)}
          className="absolute right-2.5 top-1/2 -translate-y-1/2 flex h-7 w-7 items-center justify-center rounded-md text-[var(--color-text-muted)] transition-colors hover:bg-[var(--color-mint-soft)] hover:text-[var(--color-teal-ink)] disabled:pointer-events-none disabled:opacity-50"
          aria-label={visible ? 'Ocultar texto do campo de senha' : 'Mostrar texto do campo de senha'}
          aria-pressed={visible}
        >
          {visible ? (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M1 8C1 8 3.5 3 8 3C12.5 3 15 8 15 8C15 8 12.5 13 8 13C3.5 13 1 8 1 8Z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.3"/>
            </svg>
          ) : (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M12.6 6A7.1 7.1 0 0 1 15 8C15 8 12.5 13 8 13c-.8 0-1.6-.2-2.3-.5M3.5 9.8A7.2 7.2 0 0 1 1 8C1 8 3.5 3 8 3c.8 0 1.6.2 2.3.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
              <path d="M2 2L14 14" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
              <path d="M6.3 6.4A2 2 0 0 0 6 8a2 2 0 0 0 2 2 2 2 0 0 0 1.6-.8" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
            </svg>
          )}
        </button>
      </div>
    </div>
  )
}